import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Utility } from '../../../Utilities/utility';
import { CookieService } from 'ngx-cookie-service';
import { MasterService } from 'src/app/Services/master.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-spra-openddenquiry-list',
  templateUrl: './spra-openddenquiry-list.component.html',
  styleUrls: ['./spra-openddenquiry-list.component.css']
})

export class SpraOpenddenquiryListComponent implements OnInit {
  EnquiryId:number=0;
  check: boolean=false;
  IsRental:number=0;
  EmployeeCode:string="";
  WithSaleCode: any[] = [];
  WithoutSaleCode: any[] = [];
  private utility: Utility
  constructor(
    private _MasterService: MasterService
    , private route: Router
    , private cookieService: CookieService
  ) { 
    this.utility = new Utility(this.cookieService);
  //  this.param = this.route.getCurrentNavigation()?.extras.state;
  }

  ngOnInit(): void {
   if(this.check){
     //alert('jdnc');
   }
 this.EmployeeCode='<root><EmpCode>'+this.utility.user.employeeCode+'</EmpCode></root>'
 this._MasterService.GetSpraEnquiryList(this.EmployeeCode).subscribe((d: any) => {
   
  if(d[0].Details){ 
    this.WithSaleCode=this.WithSaleCode.concat(JSON.parse(d[0].Details));
  }
   if(d[1].Details){
    this.WithoutSaleCode= this.WithoutSaleCode.concat(JSON.parse(d[1].Details));
   }
  
}, (error) => {                              //Error callback
  this.utility.Error(error);
});
  }



  OnMakeSPRA(MakeSpraData:any){
    this.IsRental = MakeSpraData.IsRental;
    let page:string = "spra-request"
    if(this.IsRental == 1){
      page = "spra-rental-request";
    }

      this.route.navigate([page], {
        state: {
          "RefId": MakeSpraData.UploadId,
          "CompanyId": MakeSpraData.CrmCompanyId,        
          "OfficeId":MakeSpraData.OfficeId,
          "SaleType":MakeSpraData.SaleType,
          "SaleCode":MakeSpraData.SaleCode,
          "OpportunityId":MakeSpraData.EnquiryId
        }
      });
  }


  OnCreateNewContact(Data:any){
   // alert(Data.Company);
    this._MasterService.GetEncrptedValue(Data.EnquiryId,Data.CompanyId,Data.PrimaryContactId).subscribe((d: any) => {
      window.location.href = environment.baseAppUrl+"/app/contact/contact-detail.aspx?value="+d; 
      this.check=true;
   }, (error) => {                              //Error callback
     this.utility.Error(error);
   });
    //this.route.navigate(['/App/Ops/srv_openDDEnquiryList.aspx']);
  
  }

}
